import React from 'react'
import PropTypes from 'prop-types'

import PieChart from '_components/audience-insights/charts/pie/index.jsx'
import useRect from '../hooks/useRect'

const legend = {
  bottom: {
    cy: '40%',
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'bottom',
    wrapperStyle: {
      width: 'fit-content',
      left: '50%',
      transform: 'translateX(-50%)',
    },
    'data-export-options': {
      layout: {
        x: 0,
        y: 0.05,
        w: 1,
        h: 0.7,
      },
    },
  },
  right: {
    cx: '45%',
    cy: '50%',
    layout: 'vertical',
    align: 'right',
    verticalAlign: 'middle',
    wrapperStyle: {
      top: '50%',
      transform: 'translateY(-50%)',
    },
    'data-export-options': {
      legendPos: 'r',
      layout: {
        x: 0.1,
        y: 0.1,
        w: 0.5,
        h: 0.8,
      },
    },
  },
  'right-small': {
    cx: '45%',
    cy: '50%',
    layout: 'vertical',
    align: 'right',
    verticalAlign: 'middle',
    wrapperStyle: {
      top: '50%',
      transform: 'translateY(-50%)',
      maxWidth: 400,
    },
    'data-export-options': {
      legendPos: 'r',
      layout: {
        x: 0.1,
        y: 0,
        w: 0.5,
        h: 1,
      },
    },
  },
}

function PieChartHOC({ data, legendPosition: position }) {
  const [Rect, rect] = useRect()
  return (
    <>
      <Rect />
      <foreignObject
        x="0"
        y="0"
        width={rect.width}
        height={rect.height}
        data-custom-render="ai-chart-pie"
        data-json={JSON.stringify(data)}
        data-export-options={JSON.stringify(legend[position]['data-export-options'])}
      >
        <PieChart
          data={data}
          hasLegend={true}
          config={{
            container: {
              width: rect.width,
              height: rect.height,
            },
            pie: {
              cx: legend[position].cx,
              cy: legend[position].cy,
            },
            legend: {
              layout: legend[position].layout,
              align: legend[position].align,
              verticalAlign: legend[position].verticalAlign,
              wrapperStyle: legend[position].wrapperStyle,
            },
          }}
        />
      </foreignObject>
    </>
  )
}

PieChartHOC.propTypes = {
  legendPosition: PropTypes.oneOf(['bottom', 'right', 'right-small']),
  data: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
    })
  ),
}

PieChartHOC.defaultProps = {
  legendPosition: 'bottom',
}

export default PieChartHOC
